<template>
  <div class="step-four">
    <div class="container">
      <div class="top-box">
        <div class="step-row">
          <el-steps
            :active="activeStep"
            simple
            finish-status="success"
            style="background-color: #fff"
          >
            <el-step title="01.填写主体信息"></el-step>
            <el-step title="02.填写店铺信息"></el-step>
            <el-step title="03.资质审核"></el-step>
            <el-step title="04.账户验证"></el-step>
          </el-steps>
        </div>

        <div class="line"></div>

        <div class="main">
          <div class="tips">
            <i class="tips-icon el-icon-warning"></i>
            <p class="tips-text">
              为保障平台运营安全有序，需通过账户验证环节验证主体真实性
            </p>
          </div>

          <el-form
            :model="form"
            :rules="rules"
            ref="form"
            size="small"
            class="form"
            label-width="380px"
            hide-required-asterisk
          >
            <el-form-item label="主体类型">
              <p>{{ this.params.type == 1 ? "个人" : "企业" }}</p>
            </el-form-item>
            <el-form-item label="公司名称">
              <p>{{ this.params.companyName }}</p>
            </el-form-item>
            <el-form-item label="统一社会信用代码">
              <p>{{ this.params.crediCode }}</p>
            </el-form-item>
            <el-form-item label="验证类型" prop="checkType">
              <el-radio-group v-model="form.checkType" @change="handleChange">
                <el-radio label="实名认证"
                  >实名认证
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="通过核实法定代表人个人信息以验证主体真实性若法定代表人名下无个人银行账户，可选择打款验证，提供对公银行账户信息进行验证"
                    placement="top"
                  >
                    <i class="el-icon-question"></i> </el-tooltip
                ></el-radio>
                <el-radio label="打款认证"
                  >打款认证
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="通过核实公司信息以验证主体真实性"
                    placement="top"
                  >
                    <i class="el-icon-question"></i> </el-tooltip
                ></el-radio>
              </el-radio-group>
            </el-form-item>
            <div v-if="form.checkType == '实名认证'">
              <el-form-item label="法定代表人姓名">
                <p>{{ params.realName }}</p>
              </el-form-item>
              <el-form-item label="法定代表人证件号码">
                <p>{{ params.idNumber }}</p>
              </el-form-item>
              <el-form-item label="法定代表人银行卡号" prop="PBankNumber">
                <el-input
                  v-model="form.PBankNumber"
                  placeholder="请填写户名为法人姓名的银行卡号"
                ></el-input>
                <a
                  class="link"
                  href="https://school.jinritemai.com/doudian/web/article/103834"
                  target="_blank"
                  rel="noopener noreferrer"
                  >银行支持列表</a
                >
              </el-form-item>
              <el-form-item label="银行预留手机号" prop="bankMobile">
                <el-input
                  v-model="form.bankMobile"
                  maxlength="11"
                  placeholder="请填写银行预留手机号码"
                ></el-input>
                <el-button
                  class="btn"
                  plain
                  :disabled="!form.bankMobile"
                  @click="open"
                  >发送验证码</el-button
                >
              </el-form-item>
              <el-form-item label="短信验证码" prop="checkCode">
                <el-input
                  v-model="form.checkCode"
                  maxlength="4"
                  placeholder="请填写验证码"
                ></el-input>
              </el-form-item>
            </div>
            <div v-else>
              <el-form-item label="银行卡号" prop="CBankNumber">
                <el-input
                  v-model="form.CBankNumber"
                  placeholder="请填写户名为公司名称的银行卡号"
                ></el-input>
              </el-form-item>
              <el-form-item label="开户银行" prop="bod">
                <el-autocomplete
                  v-model="form.bod"
                  :fetch-suggestions="querySearch"
                  placeholder="请输入开户银行"
                ></el-autocomplete>
              </el-form-item>
              <el-form-item label="开户支行所在地" prop="bankAddress">
                <el-cascader
                  v-model="form.bankAddress"
                  :options="citys"
                  :props="{ label: 'name', value: 'name' }"
                  placeholder="请选择开户支行所在地"
                  clearable
                ></el-cascader>
              </el-form-item>
              <el-form-item label="开户支行名称" prop="bankName">
                <el-input
                  v-model="form.bankName"
                  placeholder="请输入开户支行名称"
                ></el-input>
              </el-form-item>
            </div>
          </el-form>
        </div>

        <p class="give-up">
          若需重新申请店铺，可选择<span @click="handleGiveUp">放弃入驻</span
          >后按流程再次申请
        </p>
      </div>
      <div class="bottom-box">
        <button class="btn" @click="handleSubmit">验证</button>
      </div>
    </div>
  </div>
</template>

<script>
import city from "@/utils/city";
import { submit } from "@/api/chapterMock";

export default {
  data() {
    return {
      citys: city.cityArr,
      activeStep: 3,
      params: {},
      form: {
        checkType: "",
        PBankNumber: "",
        bankMobile: "",
        checkCode: "",
        CBankNumber: "",
        bod: "",
        bankAddress: [],
        bankName: "",
      },
      rules: {
        PBankNumber: {
          required: true,
          message: "请填写户名为法人姓名的银行卡号",
          trigger: "blur",
        },
        bankMobile: {
          required: true,
          message: "请填写银行预留手机号码",
          trigger: "blur",
        },
        checkCode: {
          required: true,
          message: "请填写验证码",
          trigger: "blur",
        },
        CBankNumber: {
          required: true,
          message: "请填写户名为公司名称的银行卡号",
          trigger: "blur",
        },
        bod: {
          required: true,
          message: "请选择开户银行",
          trigger: "blur",
        },
        bankAddress: {
          required: true,
          message: "请选择开户支行所在地",
          trigger: "blur",
        },
        bankName: {
          required: true,
          message: "请填写开户支行",
          trigger: "blur",
        },
      },
      restaurants: [
        { value: "中国银行" },
        { value: "中国农业银行" },
        { value: "中国建设银行" },
        { value: "中国光大银行" },
        { value: "中国工商银行" },
        { value: "交通银行" },
        { value: "兴业银行" },
        { value: "中国邮政储蓄银行" },
      ],
    };
  },
  created() {
    this.params = JSON.parse(this.$route.query.data);
  },
  mounted() {
    this.form.checkType = "实名认证";
  },
  methods: {
    open() {
      const h = this.$createElement;
      this.$notify({
        title: "验证码",
        message: h("i", { style: "color: teal" }, "YYDS"),
      });
    },
    querySearch(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },
    handleChange() {
      this.$refs.form.clearValidate();
    },
    // 放弃入驻
    handleGiveUp() {
      this.$confirm(
        "确认放弃入驻则之前的资料将被清空并终止现有流程，确认《电子商务开放平台店铺服务协议》并未成立生效?",
        "放弃入驻",
        {
          type: "warning",
        }
      )
        .then(() => {
          this.$router.push("/simulation/doudian");
        })
        .catch(() => {});
    },
    // 提交验证
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          // console.log({ ...this.form, ...this.params });
          this.$confirm(`确定要提交吗？`)
            .then(() => {
              const classChapterId = localStorage.getItem("mockChapterId");
              submit({
                classChapterId,
                content: JSON.stringify({ ...this.form, ...this.params }),
              }).then((res) => {
                this.$alert("提交成功", {
                  confirmButtonText: "确定",
                  callback: (action) => {
                    window.close();
                  },
                });
              });
            })
            .catch(() => {});
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.step-four {
  position: relative;
  width: 100%;
  min-height: 100vh;
  background: rgb(246, 246, 250);
  .top-box {
    position: relative;
    margin: 16px 0;
    height: calc(100vh - 32px - 63px);
    background-color: #fff;
    overflow-y: auto;
    .step-row {
      padding: 13px 40px;
      border-radius: 4px;
      ::v-deep .el-step.is-simple {
        .el-step__title {
          font-size: 14px;
        }
        .el-step__arrow {
          position: relative;
          &::before {
            display: none;
          }
          &::after {
            position: absolute;
            top: 8px;
            left: 6px;
            display: block;
            width: 90%;
            content: "";
            height: 4px;
            background: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNiIgaGVpZ2h0PSI0IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxyZWN0IHdpZHRoPSIyIiBoZWlnaHQ9IjQiIHJ4PSIxIiBmaWxsPSIjZWRlZWYwIi8+PC9zdmc+)
              repeat-x;
            transform: none;
          }
        }
      }
    }
    .line {
      margin: 0 auto;
      width: 90%;
      height: 1px;
      background-color: #edeef0;
    }

    .main {
      margin-top: 24px;
      padding: 0 16px;
      text-align: left;
      .tips {
        padding: 11px 0 11px 20px;
        margin-bottom: 16px;
        border-radius: 4px;
        font-size: 12px;
        line-height: 16px;
        background-color: rgba(25, 102, 255, 0.08);
        border: 1px solid rgba(25, 102, 255, 0.24);
        .tips-icon {
          display: inline-block;
          color: #1966ff;
        }

        .tips-text {
          display: inline-block;
          margin-left: 8px;
          width: 91%;
          color: #252931;
          line-height: 16px;
          vertical-align: top;
        }
      }
      ::v-deep .form {
        .el-radio {
          .el-radio__input.is-checked .el-radio__inner {
            border-color: #1966ff;
            background: #1966ff;
          }
          .el-radio__input.is-checked + .el-radio__label {
            color: inherit;
          }
        }
        .el-autocomplete,
        .el-cascader {
          width: 100%;
        }
        .el-input {
          width: 50%;
        }
        .link {
          color: #1966ff;
          margin-left: 8px;
          cursor: pointer;
        }
        .btn {
          background: #fff;
          border: 1px solid #1966ff;
          box-shadow: none;
          color: #1966ff;
          &.is-disabled {
            border-color: #8cb6ff;
            color: #8cb6ff;
          }
        }
      }
    }
    .give-up {
      position: absolute;
      bottom: 24px;
      left: 50%;
      transform: translateX(-50%);
      color: #55585c;
      text-align: center;
      span {
        color: #1966ff;
        cursor: pointer;
      }
    }
  }

  .bottom-box {
    padding: 16px 0;
    background-color: #fff;
    align-items: center;
    box-shadow: 0 -2px 4px rgba(0 0 0 / 6%);
    .btn {
      padding: 6px 16px;
      min-width: 74px;
      border-radius: 4px;
      color: #fff;
      background: #1966ff;
      border: 1px solid #1966ff;
      transition: all 0.3s ease;
      &:hover {
        background: #4784ff;
      }
    }
  }
}
</style>
<style lang="less">
.el-tooltip__popper {
  line-height: 22px;
  max-width: 240px;
}
</style>